import React from 'react';
import { Button , Typography} from '@mui/material';

/**
 * A React component that renders a single computer button.
 * 
 * @param {Object} props - The component props.
 * @param {string} props.text - The text to display on the button. Defaults to 'Single Computer'.
 * @param {string} props.variant - The button variant. Defaults to 'outlined'.
 * @param {string} props.color - The button color. Defaults to 'primary'.
 * @param {Function} props.onClick - The callback function to call when the button is clicked.
 */
const SingleComputer = ({
  text,
  variant,
  color,
  onClick, 
  selected
}) => {
  return (
    <Button
      size="small"
      variant={variant || 'outlined'}
      color={color || 'primary'}
      onClick={() => onClick()}
      sx={{
        fontFamily: 'Open Sans',
         color: selected ? '#fff' : '#363636',
        width: { xs: '100%', sm: '100%', md: '90%' },
        height: { xs: 'auto', sm: '40px' },
        padding: '10px 20px',
        margin: '0 10px',
        textTransform: 'none',
        whiteSpace: 'normal',  
        wordWrap: 'break-word', 
        overflow: 'hidden', 
        fontSize:'16px'
      }}
    >
      <Typography
        variant="button"
        sx={{
          fontSize: { xs: 'clamp(10px, 4vw, 12px)', sm: 'clamp(12px, 3vw, 14px)', md: 'clamp(14px, 2vw, 16px)' },
          textTransform: 'none',
          lineHeight: { xs: '1.2', sm: '1.4', md: '1.6' },
          letterSpacing: { xs: '0.5px', sm: '0.8px', md: '1px' },
          textAlign: 'center'
        }}
      >
        {text || 'Single Computer'}
      </Typography>
    </Button>
  )
}

/**
 * Exports the SingleComputer component as the default export.
 */
export default SingleComputer;